import React from 'react';

import { useNavigate } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import { Grid } from '@mui/material';

import { StatCard, ActionButton } from '@europrocurement/l2d-modules';
import { DataSource } from '@europrocurement/l2d-redux-utils';
import {
    AchatsAppDispatch,
    CategorieStats,
    CategorieStatsSelector,
    useAchatsService,
} from '@europrocurement/l2d-domain';
import { IconProp } from '@fortawesome/fontawesome-svg-core';

type CategoriesPanelProps = {
    afficherZeros: boolean;
    cardsProps: { [key: string]: IconProp };
};

const CategoriesPanel: React.FunctionComponent<CategoriesPanelProps> = function ({
    afficherZeros,
    cardsProps,
}) {
    const { getCategorieStats } = useAchatsService();

    const categoriesDataSource: DataSource<CategorieStats> =
        useSelector(CategorieStatsSelector).main;
    const categories = categoriesDataSource.data;

    const dispatch = useDispatch<AchatsAppDispatch>();
    const navigate = useNavigate();

    return (
        <Grid
            container
            spacing={2}
        >
            <Grid
                item
                xs={12}
            >
                <Grid
                    container
                    spacing={2}
                >
                    {[...categories]
                        .sort((a, b) => {
                            if (!a.name || !b.name) return 0;
                            if (a.name < b.name) return -1;
                            if (a.name > b.name) return 1;
                            return 0;
                        })
                        .map((categorie) =>
                            categorie.name &&
                            (!afficherZeros ? categorie.count && categorie.count !== 0 : true) ? (
                                <Grid
                                    item
                                    xs={12}
                                    sm={12}
                                    md={12}
                                    lg={4}
                                    key={`${categorie.name} • ${categorie.libelle}`}
                                >
                                    <StatCard
                                        title={`${categorie.name} • ${categorie.libelle}`}
                                        icon={cardsProps[categorie.name]}
                                        color={categorie.name}
                                        data={categorie.count}
                                        actions={
                                            [
                                                {
                                                    label: `Codes rejets ${categorie.name}`,
                                                    onClick: () => {
                                                        dispatch({
                                                            type: `${categoriesDataSource.slicename}/set${categoriesDataSource.name}Filter`,
                                                            payload: {
                                                                key: 'categories',
                                                                value: [categorie.name],
                                                            },
                                                        });
                                                        dispatch(getCategorieStats({}));
                                                        navigate('/achats/stats?tab=codeRejet');
                                                    },
                                                },
                                                {
                                                    label: `Détails ${categorie.name}`,
                                                    onClick: () => {
                                                        dispatch({
                                                            type: `${categoriesDataSource.slicename}/set${categoriesDataSource.name}Filter`,
                                                            payload: {
                                                                key: 'categories',
                                                                value: [categorie.name],
                                                            },
                                                        });
                                                        dispatch(getCategorieStats({}));
                                                        navigate('/achats/stats?tab=detail');
                                                    },
                                                },
                                            ] as ActionButton[]
                                        }
                                        sx={{
                                            minHeight: '90%',
                                        }}
                                    />
                                </Grid>
                            ) : (
                                false
                            ),
                        )}
                </Grid>
            </Grid>
        </Grid>
    );
};

export default CategoriesPanel;
